<span class="sparkle" aria-hidden="true">
	<img [src]="sparkleSrc" alt="" class="sparkle__img">
</span>

